export const getIsDev = () => ['localhost'].includes(window.location.hostname)
